<template>
  <div :class="getClassContainer()" class="bg-white view-content-layout">
  <div v-if="loading">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
    <div :class="wrapFieldsInRow ? 'row g-0 p-3' : ''">
    <template v-for="(field, idx) in nonEmptyFields">
    <div
      :key="field.key || idx"
      :class="
        getClassColumn(
          field,
          field.type === 'group' && field.key.startsWith('group_')
            ? field.key.replace('group_', '')
            : null
        )
      "
      :id="
        field.type === 'group' && field.key.startsWith('group_')
          ? 'group-notarray-group_' + field.key.replace('group_', '')
          : 'group-notarray-' + field.key
      "
      v-if="field.type !== 'group' || canViewVisualGroup(field)"
      v-show="shouldShowField(field)"
    >
      <!-- Label manual solo para campos que NO usan componentes de model-definition-core -->
      <small
        :for="field.key"
        class="form-label w-100"
        v-if="
          field.type !== 'group' &&
          field.type !== 'button' &&
          field.type !== 'list' &&
          field.type !== 'string' &&
          field.type !== 'text' &&
          field.type !== 'textarea' &&
          field.type !== 'email' &&
          field.type !== 'number' &&
          field.type !== 'date' &&
          field.type !== 'boolean' &&
          field.type !== 'select' &&
          field.type !== 'textlist' &&
          field.type !== 'reference' &&
          field.type !== 'file'
        "
      >
        <strong>
          {{ $t(field.label) }}
        </strong>
        <FieldHistoryLabelButton :field="field" />
      </small>
      <!-- Label para date (solo aquí; viewField no lo muestra) -->
      <template v-if="field.type === 'date' && !field.isArray && field.label">
        <small :for="field.key" class="form-label w-100">
          <strong>{{ $t(field.label) }}</strong>
          <FieldHistoryLabelButton :field="field" />
        </small>
        <br />
      </template>
      <br v-if="field.type !== 'group' && field.type !== 'list' && field.type !== 'string' && field.type !== 'text' && field.type !== 'textarea' && field.type !== 'email' && field.type !== 'number' && field.type !== 'date' && field.type !== 'boolean' && field.type !== 'select' && field.type !== 'textlist' && field.type !== 'reference' && field.type !== 'file'" />

      <div
        v-if="field.type == 'group' && subform > 1"
        class="py-1 text-primary group-container card-header d-flex justify-content-between align-items-center"
        :class="selectedModel.toLowerCase()"
      >
        <h6 class="mb-0">
          <GroupIcon v-if="field.icon" :icon="field.icon" />
          <i class="material-icons" v-if="field.label2 && !field.icon">{{
            field.label2
          }}</i>
          {{ $t(field.label) }}
        </h6>
      </div>

      <div v-if="field.type == 'group' && subform == 1" class="">
        <strong>{{ $t(field.label) }}</strong>
      </div>

      <!-- Campo textlist - Usando FieldTextList de model-definition-core -->
      <FieldTextList
        v-else-if="field.type === 'textlist' && !field.isArray"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="true"
      />


      <div
        v-if="field.type === 'group' && false"
        class="col-md-12 float-left-auto p-0"
      >
        <label
          :for="field.key"
          class="form-label cursor-pointer w-100 p-2"
          :class="open === field.key ? 'bg-primary text-white' : ''"
          @click="open === field.key ? (open = '') : (open = field.key)"
        >
          {{ $t(field.label) }}</label
        >
      </div>
      <!-- Campo select - Usando FieldSelect de model-definition-core -->
      <FieldSelect
        v-else-if="field.type === 'select' && !field.isArray"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="true"
      />

      <!-- Campo múltiple simple: cada item se renderiza con el componente de model-definition-core (sin unir por coma) -->
      <div
        v-if="
          field.isArray &&
          field.type !== 'group' &&
          ['string', 'number', 'boolean', 'date', 'email', 'textarea'].includes(field.type)
        "
      >
        <small
          v-if="field.label"
          :for="field.key"
          class="form-label w-100"
        >
          <strong>{{ $t(field.label) }}</strong>
        </small>
        <br v-if="field.label" />
        <template v-if="formData[field.key] && formData[field.key].length > 0">
          <div
            v-for="(item, idx) in formData[field.key]"
            :key="idx"
            class="view-array-item mb-1"
          >
            <FieldText
              v-if="['string', 'text', 'email', 'textarea'].includes(field.type)"
              :field="field"
              :value="item"
              mode="view"
              :item="originalFormData || formData"
              :modelName="selectedModel"
              :isGroupModel="isGroupModel"
              :showLabel="false"
            />
            <FieldNumber
              v-else-if="field.type === 'number'"
              :field="field"
              :value="item"
              mode="view"
              :item="originalFormData || formData"
              :parentItem="subform && originalFormData ? originalFormData : null"
              :modelName="selectedModel"
              :isGroupModel="isGroupModel"
              :lists="lists"
              :showLabel="false"
            />
            <FieldBoolean
              v-else-if="field.type === 'boolean'"
              :field="field"
              :value="item"
              mode="view"
              :item="originalFormData || formData"
              :modelName="selectedModel"
              :isGroupModel="isGroupModel"
              :showLabel="false"
            />
            <FieldDate
              v-else-if="field.type === 'date'"
              :field="field"
              :value="item"
              mode="view"
              :item="originalFormData || formData"
              :modelName="selectedModel"
              :isGroupModel="isGroupModel"
              :showLabel="false"
            />
          </div>
        </template>
        <span v-else class="text-muted">{{ $t('No items') }}</span>
      </div>

      <!-- Campo tipo reference - Usando FieldReference de model-definition-core -->
      <template v-else-if="field.type === 'reference'">
        <FieldReference
          :field="field"
          :value="formData[field.key] || null"
          :referenceOptions="referenceOptions[field.key] || []"
          mode="view"
          :item="originalFormData || formData"
          :modelName="selectedModel"
          :isGroupModel="isGroupModel"
          :lists="lists"
          :showLabel="true"
          @open-reference-modal="openReferenceModal"
        >
          <!-- Desligar la nota del gasto, como en el resumen financiero: la quita del
               embarque y el backend la descuelga de la línea. -->
          <template v-if="notaComercialAssignDataForField(field)" #item-actions="{ id, label }">
            <a
              v-if="id"
              href="#"
              class="text-warning"
              :title="$t('notaComercial.unapply.iconTitle')"
              @click.prevent.stop="unapplyNotaFromExpenseLine(field, id, label)"
            >
              <i class="fas fa-unlink" style="font-size: 0.75rem" aria-hidden="true"></i>
            </a>
          </template>
        </FieldReference>
        <!-- Crear una nota nueva no es lo mismo que asignar una que ya existe: si el
             contacto de la línea tiene notas con saldo, este botón las ofrece. -->
        <NotaComercialAssignButton
          v-if="notaComercialAssignDataForField(field)"
          class="ms-1"
          :contact-id="notaComercialAssignDataForField(field).contactId"
          side="supplier"
          target-type="shipping"
          :target-id="notaComercialAssignDataForField(field).shippingId"
          :expense-id="notaComercialAssignDataForField(field).expenseId"
          @assigned="onNotaComercialAssignedToExpenseLine"
        />
      </template>

      <!-- Campo de texto - Usando FieldText de model-definition-core -->
      <FieldText
        v-else-if="(field.type === 'string' || field.type === 'text' || field.type === 'textarea') && !field.isArray"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="true"
      />

      <!-- Campo de email - Usando FieldText de model-definition-core -->
      <FieldText
        v-else-if="field.type === 'email' && !field.isArray"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="true"
      />

      <!-- Campo de fecha -->
      <ListEditField
        v-else-if="field.type === 'date' && !field.isArray && field.listedit"
        :field="field"
        :value="formData[field.key]"
        :item="originalFormData"
        @field-updated="handleFieldUpdated"
      />
      <FieldDate
        v-else-if="field.type === 'date' && !field.isArray"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="subform ? formData : originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="false"
      />

      <!-- Status de shipping con colores (campo number) -->
      <ShippingStatusBadge
        v-else-if="field.type === 'number' && field.key === 'status' && selectedModel === 'shipping' && (originalFormData || formData)"
        :item="originalFormData || formData"
        :model-name="selectedModel"
        size="normal"
      />

      <!-- Campo numérico - Usando FieldNumber de model-definition-core -->
      <template v-else-if="field.type === 'number' && !field.isArray">
        <FieldNumber
          :field="field"
          :value="formData[field.key]"
          mode="view"
          :item="originalFormData || formData"
          :parentItem="subform && originalFormData ? originalFormData : null"
          :rowItem="subform ? expenseRowWithCurrency() : null"
          :modelName="selectedModel"
          :isGroupModel="isGroupModel"
          :lists="lists"
          :showLabel="true"
        />
        <!-- Importe después de las notas comerciales del gasto: solo se muestra, no calcula -->
        <NotaComercialAmountNet
          v-if="notaComercialNoteIdsForAmountField(field)"
          class="ms-2"
          :note-ids="notaComercialNoteIdsForAmountField(field)"
          :amount="formData[field.key]"
          :shipping-id="notaComercialShippingIdForAmountField(field)"
        />
      </template>

      <!-- Campo autoincrement -->
      <span v-else-if="field.type === 'autoincrement'">
        {{ formData[field.key] }}
      </span>

      <!-- Campo booleano (edición en vista si listedit) -->
      <ListEditField
        v-else-if="field.type === 'boolean' && !field.isArray && field.listedit"
        :field="field"
        :value="formData[field.key]"
        :item="originalFormData"
        @field-updated="handleFieldUpdated"
      />
      <FieldBoolean
        v-else-if="field.type === 'boolean'"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="true"
      />

      <!-- Campo imagen múltiple -->
      <div v-else-if="field.type === 'image' && field.isArray" class="view-image-container">
        <div v-if="formData[field.key] && Array.isArray(formData[field.key]) && formData[field.key].length > 0" class="d-flex flex-wrap gap-2">
          <img 
            v-for="(img, idx) in formData[field.key]"
            :key="idx"
            :src="img" 
            :alt="field.label + ' ' + (idx + 1)"
            class="view-image"
            style="cursor: pointer;"
            @click="openImageInNewTab(img)"
          />
        </div>
        <span v-else class="text-muted">{{ $t('No image') }}</span>
      </div>
      <!-- Campo imagen única -->
      <div v-else-if="field.type === 'image'" class="view-image-container">
        <img 
          v-if="formData[field.key]" 
          :src="formData[field.key]" 
          :alt="field.label"
          class="view-image"
          @click="openImageInNewTab(formData[field.key])"
        />
        <span v-else class="text-muted">{{ $t('No image') }}</span>
      </div>

      <!-- Campo archivo (edición en vista si listedit) -->
      <ListEditField
        v-else-if="field.type === 'file' && field.listedit"
        :field="field"
        :value="formData[field.key]"
        :item="originalFormData"
        @field-updated="handleFieldUpdated"
      />
      <!-- Campo archivo (simple o array) - FieldFile / viewField -->
      <FieldFile
        v-else-if="field.type === 'file'"
        :field="field"
        :value="formData[field.key]"
        mode="view"
        :item="originalFormData || formData"
        :modelName="selectedModel"
        :isGroupModel="isGroupModel"
        :showLabel="true"
      />

      <!-- Campo múltiple grupo -->
      <div
        v-else-if="
          field.isArray &&
          field.type === 'group' &&
          formData[field.key] &&
          formData[field.key].length > 0
        "
        :class="subform == 1 ? '' : ''"
      >
        <div class="bg-light border-radius p-2">
          <div v-for="(item, idx) in formData[field.key]" :key="idx">
            <ViewContent
              v-if="originalFormData"
              :parentFormData="originalFormData"
              :fields="field.fields"
              :value="formData[field.key][idx]"
              @input="(val) => updateGroupArray(field.key, idx, val)"
              :lists="lists"
              :models="models"
              :showButtons="false"
              :defaultRules="defaultRules ? defaultRules : rules"
              :subform="1"
              @submit.prevent
              :multiple="true"
              :fieldParent="field"
              :selectedModel="selectedModel + '_' + field.key"
              :originalSelectedModel="originalSelectedModel"
              :parentID="
                formData[field.key] &&
                formData[field.key][idx] &&
                formData[field.key][idx]._id
                  ? formData[field.key][idx]._id
                  : null
              "
              @reference-saved="$emit('reference-saved', $event)"
            />
          </div>
        </div>
      </div>

      <!-- Campo grupo simple (no múltiple) -->
      <div v-else-if="field.type === 'group' && !field.isArray" class="">
        <div class="container d-block">
          <ViewContent
            class="border-radius card-body row"
            v-if="originalFormData"
            :parentFormData="originalFormData"
            :fields="field.fields"
            :value="formData[field.key] || {}"
            :lists="lists"
            :models="models"
            :defaultRules="defaultRules ? defaultRules : rules"
            :subform="2"
            :showButtons="false"
            @input="(val) => updateGroupArray(field.key, idx, val)"
            @submit.prevent
            :selectedModel="selectedModel"
            :parentID="
              parentID
                ? parentID
                : formData && formData._id
                ? formData._id
                : null
            "
            @openReferenceModal="$emit('openReferenceModal', $event)"
            @reference-saved="$emit('reference-saved', $event)"
          />
        </div>
      </div>

      <!-- Campo array de objetos -->
      <div
        v-else-if="field.type === 'array' && field.itemFields"
        class="border p-2"
      >
        <div
          v-for="(item, idx) in formData[field.key]"
          :key="idx"
          class="mb-2 border-bottom pb-2"
        >
          <ViewContent
            v-if="originalFormData"
            :parentFormData="originalFormData"
            :fields="field.itemFields"
            v-model="formData[field.key][idx]"
            :defaultRules="defaultRules ? defaultRules : rules"
            @input="(val) => updateGroupArray(field.key, idx, val)"
            :lists="lists"
            :models="models"
            :subform="3"
            :showButtons="false"
            @submit.prevent
            :selectedModel="selectedModel"
            :parentID="
              parentID
                ? parentID
                : formData && formData._id
                ? formData._id
                : null
            "
            @openReferenceModal="$emit('openReferenceModal', $event)"
            @reference-saved="$emit('reference-saved', $event)"
          />
        </div>
      </div>

      <!-- Campo array de tipos simples -->
      <div v-else-if="field.type === 'array'" class="border p-2">
        <div
          v-for="(item, idx) in formData[field.key]"
          :key="idx"
          class="mb-2 d-flex align-items-center"
        >
          <span
            v-if="
              (field.type === 'string' || field.type === 'email') &&
              typeof formData[field.key][idx] === 'string'
            "
          >
            {{ formData[field.key][idx] }}
          </span>
          <span
            v-else-if="
              field.type === 'number' &&
              typeof formData[field.key][idx] === 'number'
            "
          >
            <FieldNumber
              :field="field"
              :value="formData[field.key][idx]"
              mode="view"
              :item="originalFormData || formData"
              :parentItem="subform && originalFormData ? originalFormData : null"
              :modelName="selectedModel"
              :isGroupModel="isGroupModel"
              :lists="lists"
              :showLabel="false"
            />
          </span>
          <span
            v-else-if="
              field.type === 'autoincrement' &&
              typeof formData[field.key][idx] === 'number'
            "
          >
            {{ formData[field.key][idx] }}
          </span>
        </div>
      </div>

      <!-- Campo list - Usando FieldList de model-definition-core -->
      <div v-if="field.type === 'list' && field.listType">
        <!-- Label del campo (mostrar arriba, antes de los badges) -->
        <small
          v-if="field.label"
          :for="field.key"
          class="form-label w-100"
        >
          <strong>
            {{ $t(field.label) }}
          </strong>
        </small>
        <br v-if="field.label" />
        
        <!-- Para arrays: siempre pasar un array de ítems al v-for; si llega string "a, b" normalizar a [a, b] para no enviar ya unido por coma -->
        <template v-if="field.isArray && getListArrayValues(field).length > 0">
          <span
            v-for="(listItem, i) in getListArrayValues(field)"
            :key="i"
            class="badge badge-primary m-1 clickable-badge cursor-pointer d-inline-block"
            @click.stop="navigateToFilteredList(field, listItem)"
            :title="$t('Click to filter by this value')"
          >
            <FieldList
              :field="field"
              :value="listItem"
              mode="view"
              :item="originalFormData || formData"
              :modelName="selectedModel"
              :isGroupModel="isGroupModel"
              :lists="lists"
              :showLabel="false"
            />
          </span>
        </template>
        <span v-else-if="field.isArray" class="text-muted">
          {{ $t('No selection') }}
        </span>
        <!-- Para valores simples, mostrar en un badge clickeable -->
        <span
          v-else-if="formData[field.key]"
          class="badge badge-primary clickable-badge cursor-pointer d-inline-block"
          @click.stop="navigateToFilteredList(field, formData[field.key])"
          :title="$t('Click to filter by this value')"
        >
          <FieldList
            :field="field"
            :value="formData[field.key]"
            mode="view"
            :item="originalFormData || formData"
            :modelName="selectedModel"
            :isGroupModel="isGroupModel"
            :lists="lists"
            :showLabel="false"
          />
        </span>
        <span v-else class="text-muted">
          {{ $t('No selection') }}
        </span>
      </div>

      <!-- Campo select visual de iconos (tipo "icon") -->
      <div v-else-if="field.type === 'icon'">
        <div class="d-flex flex-wrap">
          <span
            v-for="icon in field.icons || defaultIcons"
            :key="icon"
            class="icon-select-option"
            :class="{ selected: formData[field.key] === icon }"
            @click="formData[field.key] = icon"
            style="
              cursor: pointer;
              margin: 4px;
              padding: 6px;
              border-radius: 6px;
              border: 1px solid #eee;
              display: flex;
              align-items: center;
            "
          >
            <i
              class="material-icons"
              :style="{
                fontSize: '28px',
                color: formData[field.key] === icon ? 'var(--bs-primary)' : '#888',
              }"
              >{{ icon }}</i
            >
            <span
              v-if="formData[field.key] === icon"
              style="margin-left: 4px; color: var(--bs-primary)"
              >✔</span
            >
          </span>
        </div>
      </div>

      <!-- Campo tipo list -->
      <span
        v-if="
          field.type === 'list' && field.list && referenceOptions[field.key]
        "
      >
        {{ $translatedListLabel(formData[field.key]) }}
      </span>

      <!-- Otros tipos pueden agregarse aquí -->
    </div>
    <!-- Gasto del embarque en otra moneda: su importe en la moneda del sistema (#397) -->
    <OperationUsdEquivalent
      v-if="usdEquivalentAfterField(field)"
      :key="'usd-equivalent-' + (field.key || idx)"
      :column-class="getClassColumn(field)"
      :shipping-id="String(formData.shipping || formData.parent || '')"
      :amount="formData.amount"
      :currency-id="expenseRowWithCurrency().currencyex"
      :lists="lists"
    />
    </template>
    </div>

    <!-- Botones solo si showButtons es true -->
    <!-- ReferenceModal -->

    <ReferenceModal
      v-if="showReferenceModal && currentReferenceField"
      :is-visible="showReferenceModal"
      :model-name="currentReferenceField.ref"
      :model-label="currentReferenceField.label"
      :lists="lists"
      :models="models"
      :editing-item="currentEditingItem"
      @saved="handleReferenceSaved"
      @close="showReferenceModal = false"
      :parentID="parentID"
      :selectedModel="selectedModel"
    />

    <!-- Nota comercial creada desde una línea de gastos -->
    <NotaComercialNoteModal
      ref="notaComercialNoteModal"
      :lists="lists"
      @saved="handleNotaComercialFromExpenseSaved"
    />

  </div>
</template>

<script>
import GroupIcon from "@/components/gotrading/common/GroupIcon.vue";
import { wencesApi } from "@/api/wencesApi";
import {
  isShippingExpenseRow,
  notaComercialModalContextFromExpenseLine,
} from "@/modules/nota_comercial_module/utils/notaComercialFromExpenseLine";
import NotaComercialNoteModal from "@/modules/nota_comercial_module/components/NotaComercialNoteModal.vue";
import NotaComercialAssignButton from "@/modules/nota_comercial_module/components/NotaComercialAssignButton.vue";
import NotaComercialAmountNet from "@/modules/nota_comercial_module/components/NotaComercialAmountNet.vue";
import notaComercialUnapplyMixin from "@/modules/nota_comercial_module/mixins/notaComercialUnapplyMixin";
import OperationUsdEquivalent from "@/modules/exchange_rates_module/components/OperationUsdEquivalent.vue";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { evaluate } from "mathjs";
import FileDisplay from "./FileDisplay.vue";
// Componentes legacy removidos - ahora se usan componentes de model-definition-core
import ListEditField from "./ListEditField.vue";
import permissionsMixin from "@/mixins/permissionsMixin";
import { 
  FieldText, 
  FieldList, 
  FieldNumber, 
  FieldDate, 
  FieldBoolean, 
  FieldSelect, 
  FieldTextList, 
  FieldReference, 
  FieldFile 
} from "../model-definition-core";
import ShippingStatusBadge from "./ShippingStatusBadge.vue";
import FieldHistoryLabelButton from "./FieldHistoryLabelButton.vue";
import { getTranslatedListLabel } from "@/utils/listItemI18n";
import { findTeuService } from "@/services/findTeuService";

export default {
  name: "ViewContent",
  mixins: [permissionsMixin, notaComercialUnapplyMixin],
  provide() {
    const vm = this;
    return {
      findTeuAutoTrackingContext: this.findTeuAutoTrackingContext,
      // Registro para el botón de historial del label (FieldHistoryLabelButton). Solo en la
      // ficha: las filas de grupos son otros registros y no llevan botón.
      fieldHistoryContext: {
        get modelName() {
          return vm.selectedModel;
        },
        get itemId() {
          if (vm.subform || vm.multiple) return null;
          const id = vm.formData && vm.formData._id;
          return id ? String(id) : null;
        },
      },
    };
  },
  inject: {
    dashboardLayout: { default: null },
  },
  props: {
    parentFormData: { type: Object, required: false, default: () => {} },
    fieldParent: { type: [String, Object, null], required: false, default: "" },
    visualGroups: { type: Array, required: false, default: () => [] },
    activeVisualGroup: { type: String, required: false, default: null },
    fields: { type: Array, required: true },
    subform: { type: [Boolean, Number, null], default: false },
    defaultRules: { type: Array },
    value: { type: Object, required: true },
    selectedModel: { type: String, required: false, default: "" },
    originalSelectedModel: { type: String, required: false, default: "" },
    lists: { type: Array, required: false, default: () => [] },
    models: { type: Array, required: false, default: () => [] },
    showButtons: { type: Boolean, default: true },
    multiple: { type: Boolean, default: false },
    parentID: { type: String, required: false, default: "" },
    model: {
      type: Object,
      required: false,
    },
    // ✅ Nueva prop para detectar modelos de grupo
    isGroupModel: { type: Boolean, default: false },
    /** Vista detalle dinámico: rejilla ~50% de ancho y fila Bootstrap */
    detailHalfWidthFields: { type: Boolean, default: false },
  },
  data() {
    return {
      originalFormData: false,
      loading: true,
      isUploadingImage: false,
      internalFields: [],
      formData: {},
      open: false,
      referenceOptions: {},
      referenceLoaded: false,
      rules: [],
      referenceItems: [],
      defaultIcons: [
        "home",
        "star",
        "favorite",
        "person",
        "settings",
        "check",
        "close",
        "info",
        "warning",
        "help",
        "dashboard",
        "event",
        "email",
        "phone",
        "lock",
        "search",
        "shopping_cart",
        "chat",
        "camera",
        "notifications",
        "location_on",
        "folder",
        "delete",
        "add",
        "arrow_forward",
        "arrow_back",
        "cloud",
        "battery_full",
        "schedule",
        "volume_up",
        "music_note",
        "brightness_7",
        "language",
        "fingerprint",
        "accessibility",
        "edit",
        "print",
        "map",
        "flash_on",
        "photo_camera",
        "assignment",
        "reorder",
        "delete_forever",
        "restore",
        "storage",
        "security",
        "account_circle",
        "call",
        "airplanemode_active",
        "directions",
        "explore",
        "poll",
        "today",
        "group",
        "show_chart",
        "touch_app",
        "developer_mode",
        "build",
        "location_searching",
        "camera_alt",
        "people",
        "stars",
        "swap_horiz",
        "swap_vert",
        "visibility",
        "play_arrow",
        "pause",
        "skip_next",
        "skip_previous",
        "stop",
        "settings_backup_restore",
        "access_alarm",
        "cloud_download",
        "cloud_upload",
        "alarm",
        "radio_button_checked",
        "radio_button_unchecked",
        "check_circle",
        "error",
        "message",
        "system_update",
        "add_circle",
        "remove_circle",
        "remove_circle_outline",
        "check_box",
        "indeterminate_check_box",
        "highlight_off",
        "save",
        "content_copy",
        "filter_list",
        "clear",
        "open_in_new",
        "file_copy",
        "more_vert",
        "more_horiz",
        "favorite_border",
        "flash_off",
        "battery_alert",
        "restore_from_trash",
        "tune",
        "undo",
        "redo",
        "phone_iphone",
        "tablet_android",
        "keyboard_arrow_up",
        "keyboard_arrow_down",
        "keyboard_arrow_left",
        "keyboard_arrow_right",
        "home_work",
        "business",
        "school",
        "event_note",
        "explore_off",
        "recent_actors",
        "apps",
        "alarm_add",
        "check_circle_outline",
        "check_box_outline_blank",
        "watch_later",
        "create",
        "keyboard",
        "mouse",
        "insert_emoticon",
        "autorenew",
      ],
      fieldDependencies: new Map(),
      showReferenceModal: false,
      currentReferenceField: null,
      currentEditingItem: null,
      referenceModelFields: [],
      listsLoaded: false,
      /** Línea de gastos desde la que se está creando una nota comercial. */
      notaComercialSourceExpenseRow: null,
      loadingLists: false,
      internalLists: [],
      hierarchicalLabelsCache: new Map(), // Cache para labels jerárquicos
      referenceOptionsLoading: false, // Flag para evitar múltiples llamadas a loadAllReferenceOptions
      referenceOptionsLoaded: false, // Flag para saber si ya se cargaron las referencias
      initializing: false, // Flag para evitar múltiples llamadas simultáneas a initializeComponent
      findTeuAutoTrackingContext: { modelName: "", rule: null },
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        // Si cambió el _id, significa que es un item completamente diferente
        // Necesitamos reinicializar todo el componente
        const newId = newVal && newVal._id ? newVal._id : null;
        const oldId = oldVal && oldVal._id ? oldVal._id : null;
        
        if (newId !== oldId) {
          // Es un item diferente, reinicializar completamente
          this.referenceOptionsLoaded = false; // Resetear flag para recargar referencias
          this.initializeComponent();
        } else {
          // Es el mismo item, solo actualizar los datos
          this.initializeFormData(newVal);
        }
      },
      deep: true,
    },
    fields: {
      handler() {
        this.transformFields();
      },
      immediate: true,
    },
    selectedModel: {
      handler(newVal) {
        if (newVal) {
          this.initializeComponent();
          this.loadRules();
          this.loadFindTeuAutoTrackingRule(newVal);
        } else {
          this.findTeuAutoTrackingContext.modelName = "";
          this.findTeuAutoTrackingContext.rule = null;
        }
      },
      immediate: true,
    },
    "$i18n.locale"() {
      this.hierarchicalLabelsCache.clear();
      this.$forceUpdate();
    },
  },
  async created() {
    // Inicializar formData con el valor inicial
  },
  async mounted() {
    await this.initializeComponent();
  },
  methods: {
    async loadFindTeuAutoTrackingRule(modelName) {
      const mn = String(modelName || "").trim();
      this.findTeuAutoTrackingContext.modelName = mn;
      this.findTeuAutoTrackingContext.rule = null;
      if (!mn) return;
      try {
        const rule = await findTeuService.getAutoTrackingRuleForModel(mn);
        if (this.findTeuAutoTrackingContext.modelName === mn) {
          this.findTeuAutoTrackingContext.rule = rule;
        }
      } catch (_) {
        if (this.findTeuAutoTrackingContext.modelName === mn) {
          this.findTeuAutoTrackingContext.rule = null;
        }
      }
    },
    async initializeComponent() {
      // Evitar múltiples inicializaciones simultáneas
      if (this.initializing) {
        return;
      }
      
      this.initializing = true;
      this.loading = true;
      
      try {
        await this.initializeFormData(this.value);

        if (!this.subform) {
          this.originalFormData = { ...this.formData };
        } else {
          this.originalFormData = { ...this.parentFormData };
        }
        await this.loadAllReferenceOptions();
        await this.transformFields();
        // ❌ REMOVIDO: loadLists() - Las listas se cargan bajo demanda (lazy loading) cuando se necesitan
        // await this.loadLists();
        await this.ensureAllFields();
      } finally {
        this.loading = false;
        this.initializing = false;
      }
    },
    async initializeFormData(newVal) {
      if (this.subform) {
        // Si es subformulario, usar el valor directamente
        this.formData = { ...newVal };
      } else {
        // Si es formulario principal, procesar los grupos visuales
        this.formData = { ...newVal };

        // Procesar los grupos visuales
        if (this.visualGroups && this.visualGroups.length > 0) {
          this.visualGroups.forEach((group) => {
            const groupKey = `group_${group.name}`;
            const groupData = {};

            // Obtener los campos que pertenecen a este grupo
            const groupFields = this.fields.filter(
              (field) => field.visualGroup === group.name
            );

            // Copiar los valores de los campos al objeto del grupo
            groupFields.forEach((field) => {
              if (newVal && newVal[field.key] !== undefined) {
                groupData[field.key] = newVal[field.key];
              }
            });

            // Asignar los datos del grupo
            this.$set(this.formData, groupKey, groupData);
          });
        }
        this.ensureAllFields();
      }
    },
    async executeDynamicAction(field) {
      try {
        let key = field.key;

        // Obtener el modelo actual desde las props o del contexto
        const modelName = this.selectedModel || this.$parent.selectedModel;

        if (!modelName) {
          console.error(
            "No se pudo determinar el modelo para la acción dinámica"
          );
          return;
        }

        // Llamar al endpoint del backend
        const response = await wencesApi.post(
          `/api/gotrading/dynamic/${modelName}/execute-action`,
          {
            item: this.formData,
            key: key,
            modelName: modelName,
            fieldParent: this.fieldParent,
            field: field,
          }
        );

        // Emitir evento para que el componente padre pueda manejar la respuesta
        this.$emit("dynamicActionExecuted", {
          key: key,
          result: response.data,
          formData: this.formData,
        });

        // Mostrar mensaje de éxito si hay uno
        if (response.data.message) {
          // Aquí podrías usar un sistema de notificaciones como toast
        }
      } catch (error) {
        console.error("Error ejecutando acción dinámica:", error);

        // Emitir evento de error
        this.$emit("dynamicActionError", {
          key: key,
          error: error.response?.data?.error || error.message,
          formData: this.formData,
        });
      }
    },

    async loadLists() {
      // ❌ REMOVIDO: Este método se mantiene por compatibilidad pero no se debe llamar directamente
      // Usar loadListsIfNeeded() en su lugar para lazy loading
      const { data } = await wencesApi.get("/api/gotrading/lists");
      this.referenceItems = data;
    },
    getListName(field, value) {
      //       // Logs comentados para reducir ruido en consola
      // console.log('[ViewContent.getListName] 🔍 Iniciando búsqueda:', {...});

      // Si el valor ya tiene label (viene del backend), usarlo directamente
      if (value && typeof value === 'object' && value.label) {
        // console.log('[ViewContent.getListName] ✅ Valor ya tiene label del backend:', value.label);
        return getTranslatedListLabel(value, this.$i18n.locale);
      }

      // Buscar en todas las fuentes disponibles: internalLists, referenceItems, o lists (props)
      let list = null;
      
      // 1. Buscar en internalLists (listas cargadas bajo demanda)
      if (this.internalLists && this.internalLists.length > 0) {
        list = this.internalLists.find((item) => item.type === field.listType);
        // if (list) { console.log('[ViewContent.getListName] ✅ Lista encontrada en internalLists:', field.listType); }
      }
      
      // 2. Si no está, buscar en referenceItems (listas cargadas tradicionalmente)
      if (!list && this.referenceItems && this.referenceItems.length > 0) {
        list = this.referenceItems.find((item) => item.type === field.listType);
        // if (list) { console.log('[ViewContent.getListName] ✅ Lista encontrada en referenceItems:', field.listType); }
      }
      
      // 3. Si no está, buscar en lists (props - especialmente importante para subforms)
      if (!list && this.lists && this.lists.length > 0) {
        // console.log('[ViewContent.getListName] 🔍 Buscando en lists (props):', {...});
        list = this.lists.find((item) => item.type === field.listType);
        // if (list) { console.log('[ViewContent.getListName] ✅ Lista encontrada en lists (props):', field.listType, 'con', list.values?.length || 0, 'valores'); }
        // else { console.log('[ViewContent.getListName] ❌ Lista NO encontrada en lists (props):', field.listType); }
      }
      
      // Si encontramos la lista, buscar el valor
      if (field.type === "list" && list && list.values) {
        const option = list.values.find((item) => item && item._id == value);
        if (option && option.label) {
          // console.log('[ViewContent.getListName] ✅ Opción encontrada:', option.label);
          return getTranslatedListLabel(option, this.$i18n.locale);
        } else {
          // console.log('[ViewContent.getListName] ⚠️ Lista encontrada pero opción no encontrada para value:', value);
        }
      }

      // Si no está en ninguna lista disponible, intentar cargar bajo demanda (solo si no es subform)
      if (field.type === "list" && field.listType && !this.subform) {
        // console.log('[ViewContent.getListName] 📡 Intentando cargar lista bajo demanda:', field.listType);
        // Verificar si ya tenemos esta lista específica
        const existingList = this.internalLists.find(l => l.type === field.listType);
        if (!existingList && !this.loadingLists) {
          this.loadListsIfNeeded('getListName', field.listType).then(() => {
            const availableLists = this.internalLists;
            const foundList = availableLists.find((l) => l.type === field.listType);
            if (foundList && foundList.values) {
              const option = foundList.values.find((item) => item && item._id == value);
              if (option && option.label) {
                this.$forceUpdate();
              }
            }
          });
        }
      } else if (this.subform) {
        // console.log('[ViewContent.getListName] ⚠️ Es subform y no se encontró la lista. No se puede cargar bajo demanda aquí.');
      }

      // console.log('[ViewContent.getListName] ❌ Retornando value sin procesar:', value);
      return value;
    },
    navigateToFilteredList(field, value) {
      // Obtener el ID del valor (puede ser un objeto con _id o un string)
      let valueId = null;
      if (value && typeof value === 'object' && value._id) {
        valueId = value._id;
      } else if (value && typeof value === 'string') {
        valueId = value;
      }
      
      if (!valueId || !this.selectedModel || !field?.key) return;
      
      // Usar originalSelectedModel si existe (para modelos de grupo), sino selectedModel
      const modelName = this.originalSelectedModel || this.selectedModel;
      const url = `/dynamic-model/${modelName}?${field.key}=${valueId}`;
      this.$router.push(url);
    },
    // Método auxiliar para verificar si hay listas disponibles en cualquier fuente
    hasAnyListsAvailable() {
      return (this.internalLists && this.internalLists.length > 0) ||
             (this.referenceItems && this.referenceItems.length > 0) ||
             (this.lists && this.lists.length > 0);
    },
    getClassContainer() {
      if (this.multiple && this.subform == 2) {
        return "d-flex flex-wrap gap-1  ";
      }

      if (this.multiple && this.subform == 1) {
        return "d-flex flex-wrap gap-1 border-primary border mb-2 border-radius py-1";
      }

      if (!this.subform) {
        return this.selectedModel.toLowerCase();
      }

      return "";
    },
    getClassColumn(field, groupName = null) {
      let baseClass = "";
      const useHalfWidthGrid =
        !this.subform &&
        !this.multiple &&
        ((this.visualGroups && this.visualGroups.length > 0) ||
          this.detailHalfWidthFields) &&
        !(
          field.type === "group" &&
          field.key &&
          String(field.key).startsWith("group_")
        );

      if (this.multiple && this.subform == 2) {
        baseClass =
          "flex-grow-1 mb-2 text-left " + field.type + " " + field.key;
      } else if (this.multiple && this.subform == 1) {
        baseClass = " mx-2  float-left-auto " + field.type + " " + field.key;
      } else if (field.isArray && field.type === "group") {
        baseClass =
          "group-isarray col-12  " +
          field.type +
          " key-" +
          field.key;
      } else if (field.type === "group") {
        // Para grupos visuales, usar la clase especial
        if (groupName && field.key.startsWith("group_")) {
          baseClass =
            "border-primary border-radius border mb-4 group-notarray-group_ col-12 p-2 " +
            field.type +
            " key-" +
            field.key;
          // Agregar clase active si es el grupo activo
          if (this.activeVisualGroup === groupName) {
            baseClass += " active ";
          }
        } else {
          baseClass =
            "group-notarray card mb-2 px-1 col-12 p-0  bg-light " +
            field.type +
            " key-" +
            field.key;
        }
      } else if (field.type === "list") {
        if (useHalfWidthGrid) {
          baseClass =
            "col-12 col-md-6 p-1 " + field.type + " key-" + field.key;
        } else {
          baseClass =
            "col-12 col-md-6 col-lg-4 p-1 float-left " +
            field.type +
            " key-" +
            field.key;
        }
      } else if (field.type === "array") {
        baseClass =
          (useHalfWidthGrid
            ? "col-12 col-md-6 p-1 "
            : "col-12 col-md-12 col-lg-4 p-1 ") +
          field.type +
          " key-" +
          field.key;
      } else {
        baseClass =
          (useHalfWidthGrid
            ? "col-12 col-md-6 p-1  "
            : "col-12 col-md-6 col-lg-4 p-1  ") +
          field.type +
          " key-" +
          field.key;
      }

      return baseClass;
    },
    async ensureAllFields() {
      this.internalFields.forEach((field) => {
        if (this.formData[field.key] === undefined) {
          if (field.isArray) {
            this.$set(this.formData, field.key, []);
          } else if (field.type === "array") {
            this.$set(this.formData, field.key, []);
          } else if (field.type === "group") {
            this.$set(this.formData, field.key, {});
          } else {
            this.$set(this.formData, field.key, "");
          }
        }
      });
    },
    /**
     * Para list isArray: devuelve siempre un array de ítems para renderizar.
     * Si el valor llega como string "40 Reefer, 20 Dry" (backend o capa intermedia),
     * lo normaliza a ["40 Reefer", "20 Dry"] para que cada ítem se pase al FieldList por separado.
     */
    getListArrayValues(field) {
      const raw = this.formData[field.key];
      if (raw == null || raw === "") return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "string") {
        return raw.split(/\s*,\s*/).map((s) => s.trim()).filter(Boolean);
      }
      return [raw];
    },
    findInAction(searchString) {
      if (Array.isArray(this.defaultRules)) {
        return this.defaultRules.filter(
          (item) => item.action && item.action.includes(searchString)
        );
      }
      return [];
    },
    onFieldChange(fieldKey, value) {
      let rule = this.findInAction(fieldKey);

      if (rule && rule.length > 0) {
        // Evaluar reglas después de cada cambio
        this.evaluateRules(fieldKey, rule[0]);
      }
      if (this.subform) {
        // Si el valor es un objeto con _id, usar solo el _id
        if (value && typeof value === "object" && value._id) {
          this.formData[fieldKey] = value._id;
        } else {
          this.formData[fieldKey] = value;
        }
        this.$emit("input", this.formData);
      }
    },
    addArrayItem(field) {
      if (!this.formData[field.key]) {
        this.$set(this.formData, field.key, []);
      }

      // Crear un nuevo objeto con todos los campos del grupo inicializados
      const newGroup = {};
      field.fields.forEach((subField) => {
        // Inicializar cada campo según su tipo
        switch (subField.type) {
          case "number":
            newGroup[subField.key] = 0;
            break;
          case "boolean":
            newGroup[subField.key] = false;
            break;
          case "date":
            newGroup[subField.key] = new Date().toISOString().split("T")[0];
            break;
          case "reference":
          case "list":
            newGroup[subField.key] = null;
            break;
          default:
            newGroup[subField.key] = "";
        }
      });

      this.formData[field.key].push(newGroup);
      // Emitir el cambio al componente padre
      this.$emit("input", this.formData);
    },
    removeArrayItem(key, idx) {
      this.formData[key].splice(idx, 1);
    },
    async onImageChange(event, key) {
      const file = event.target.files[0];
      if (file) {
        // Validar tamaño (5MB máximo)
        if (file.size > 5 * 1024 * 1024) {
          this.$swal?.fire?.({
            title: "Error",
            text: "El archivo es demasiado grande. El tamaño máximo permitido es 5MB.",
            icon: "error",
          });
          event.target.value = "";
          return;
        }

        // Validar tipo de archivo
        if (!file.type.startsWith("image/")) {
          this.$swal?.fire?.({
            title: "Error",
            text: "Por favor, selecciona un archivo de imagen válido.",
            icon: "error",
          });
          event.target.value = "";
          return;
        }

        // Mostrar preview temporal mientras sube
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$set(this.formData, key, e.target.result);
        };
        reader.readAsDataURL(file);

        // Subir a S3 inmediatamente
        this.isUploadingImage = true;
        const uploadResult = await this.uploadImageToS3(file);
        this.isUploadingImage = false;

        if (uploadResult.ok) {
          this.$set(this.formData, key, uploadResult.url);
          this.$emit("input", this.formData);
        } else {
          this.$swal?.fire?.({
            title: "Error",
            text: uploadResult.message || "Error al subir la imagen",
            icon: "error",
          });
          // Limpiar el campo si falló la subida
          this.$set(this.formData, key, null);
          event.target.value = "";
        }
      }
    },
    async uploadImageToS3(file) {
      const formDataUpload = new FormData();
      formDataUpload.append('image', file);

      try {
        const response = await wencesApi.post('/api/upload/upload-public', formDataUpload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        return { ok: true, url: response.data.url };
      } catch (error) {
        console.error('Error uploading image:', error);
        return { ok: false, message: error.response?.data?.message || 'Error al subir la imagen' };
      }
    },
    async onSubmit() {
      try {
        // Crear una copia del formulario para no modificar el original
        const dataToSend = { ...this.formData };

        if (!this.subform) {
          // Emitir el evento submit con los datos limpios
          this.$emit("submit", dataToSend);
        }
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }
    },
    getAllFields(fields) {
      let all = [];
      fields.forEach((field) => {
        all.push(field);
        if (field.fields && Array.isArray(field.fields)) {
          all = all.concat(this.getAllFields(field.fields));
        }
        if (field.itemFields && Array.isArray(field.itemFields)) {
          all = all.concat(this.getAllFields(field.itemFields));
        }
      });
      return all;
    },
    async loadAllReferenceOptions() {
      // Evitar llamadas duplicadas simultáneas
      if (this.referenceOptionsLoading) {
        return;
      }
      
      // Si ya se cargaron y no hay cambios, no volver a cargar
      if (this.referenceOptionsLoaded && Object.keys(this.referenceOptions).length > 0) {
        return;
      }
      
      // Si estamos inicializando en el componente principal, no cargar referencias aquí
      // Pero los subforms (componentes anidados) siempre deben cargar sus referencias
      if (this.initializing && !this.subform) {
        return;
      }
      
      // Para subforms, resetear el flag si es necesario para permitir la carga
      if (this.subform && this.referenceOptionsLoaded) {
        // Los subforms siempre deben poder cargar sus referencias
        this.referenceOptionsLoaded = false;
      }
      
      this.referenceOptionsLoading = true;
      this.referenceLoaded = false;
      
      // Crear un Map para almacenar los modelos únicos y los IDs que realmente necesitamos cargar
      const uniqueRefsToLoad = new Map();

      // Función auxiliar para procesar un campo reference
      const processReferenceField = (field, value, isInsideGroup = false) => {
        if (!value) return;

        // Si el campo está dentro de un group, siempre cargarlo (el backend no popula estas referencias)
        const forceLoad = isInsideGroup;

        // Si es un array de referencias
        if (field.isArray && Array.isArray(value)) {
          const missingRefs = [];
          const existingRefs = [];
          
          value.forEach((v) => {
            if (!v) return;
            // Si está dentro de un group, siempre tratarlo como que necesita carga
            if (forceLoad) {
              const id = typeof v === "string" ? v : (v._id ? v._id : v);
              if (id) {
                missingRefs.push(id);
              }
            } else {
              // Si ya viene como objeto con _id y name, ya está populado del backend
              if (typeof v === "object" && v._id && v.name) {
                existingRefs.push(v);
              } else {
                // Si es solo un ID (string o _id), necesitamos cargarlo
                const id = typeof v === "string" ? v : (v._id ? v._id : v);
                if (id) {
                  missingRefs.push(id);
                }
              }
            }
          });
          
          // Si hay referencias que ya vienen populadas, usarlas directamente
          if (existingRefs.length > 0 && !forceLoad) {
            this.$set(this.referenceOptions, field.key, existingRefs);
          }
          
          // Cargar las que faltan
          if (missingRefs.length > 0) {
            if (!uniqueRefsToLoad.has(field.ref)) {
              uniqueRefsToLoad.set(field.ref, new Set());
            }
            missingRefs.forEach((id) => uniqueRefsToLoad.get(field.ref).add(id));
          }
        }
        // Si es una referencia simple
        else {
          // Si está dentro de un group, siempre tratarlo como que necesita carga
          if (forceLoad) {
            const id =
              value && typeof value === "string"
                ? value
                : value && value._id
                ? value._id
                : value;
            if (id) {
              if (!uniqueRefsToLoad.has(field.ref)) {
                uniqueRefsToLoad.set(field.ref, new Set());
              }
              uniqueRefsToLoad.get(field.ref).add(id);
            }
          } else {
            // Si ya viene como objeto con _id y name, ya está populado del backend
            if (typeof value === "object" && value._id && value.name) {
              // Ya viene populado, usar directamente
              this.$set(this.referenceOptions, field.key, [value]);
            } else {
              // Si es solo un ID, necesitamos cargarlo
              const id =
                value && typeof value === "string"
                  ? value
                  : value && value._id
                  ? value._id
                  : value;
              if (id) {
                if (!uniqueRefsToLoad.has(field.ref)) {
                  uniqueRefsToLoad.set(field.ref, new Set());
                }
                uniqueRefsToLoad.get(field.ref).add(id);
              }
            }
          }
        }
      };

      // Primero, verificar qué referencias ya vienen populadas del backend y cuáles necesitamos cargar
      for (const field of this.internalFields) {
        if (field.type === "reference" && field.ref) {
          const value = this.formData[field.key];
          processReferenceField(field, value, false);
        }
        // NO procesar campos dentro de grupos aquí - los ViewContent anidados (subforms) se encargarán
        // Solo procesar campos reference directos del componente actual
      }
      
      // Solo hacer llamadas a la API para las referencias que realmente faltan
      if (uniqueRefsToLoad.size > 0) {
        // Luego, hacer una llamada por cada modelo único con sus IDs específicos que faltan
        for (const [ref, ids] of uniqueRefsToLoad) {
          try {
            // Construir el query string con los IDs específicos
            const params = new URLSearchParams();
            params.append("_id", Array.from(ids).join(","));

            const { data } = await wencesApi.get(
              `/api/gotrading/dynamic/${ref}?${params.toString()}`
            );
            
            // Asignar los datos a todos los campos que referencian este modelo
            // Si ya había datos, combinarlos
            for (const field of this.internalFields) {
              if (field.type === "reference" && field.ref === ref) {
                const existing = this.referenceOptions[field.key] || [];
                const combined = Array.isArray(existing) ? [...existing, ...data] : data;
                this.$set(this.referenceOptions, field.key, combined);
              }
              // NO procesar campos dentro de grupos aquí
              // Los ViewContent anidados (subforms) cargarán sus propias referencias
            }
          } catch (error) {
            console.error(`[ViewContent.loadAllReferenceOptions] ❌ Error loading reference options for ${ref}:`, error);
            // Solo asignar array vacío si no había datos previos
            for (const field of this.internalFields) {
              if (field.type === "reference" && field.ref === ref && !this.referenceOptions[field.key]) {
                this.$set(this.referenceOptions, field.key, []);
              }
            }
          }
        }
      }

      this.referenceLoaded = true;
      this.referenceOptionsLoaded = true;
      this.referenceOptionsLoading = false;
    },
    async loadRules() {
      if (this.selectedModel) {
        try {
          if (this.defaultRules) {
            this.rules = this.defaultRules;
          } else {
            const { data } = await wencesApi.get(
              `/api/gotrading/rules/${this.selectedModel}`
            );
            this.rules = data;
          }
        } catch (error) {
          this.rules = [];
        }
      }
    },
    updateGroupArray(fieldKey, index, value) {
      // Asegurarse de que el array existe
      if (!this.formData[fieldKey]) {
        this.$set(this.formData, fieldKey, {});
      }
      // Actualizar el elemento específico del array
      this.$set(this.formData, fieldKey, value);
      // Emitir el cambio al componente padre
      this.$emit("input", this.formData);
    },
    transformFields() {
      if (this.fields && this.visualGroups && this.visualGroups.length > 0) {
        // Crear un mapa de campos por grupo visual
        const fieldsByGroup = new Map();
        this.visualGroups.forEach((group) => {
          fieldsByGroup.set(group.name, {
            key: `group_${group.name}`,
            label: this.$t(group.label),
            type: "group",
            icon: group.icon,
            fields: [],
          });
        });

        // Mantener el orden original de los campos
        this.internalFields = this.fields
          .map((field) => {
            if (field.visualGroup && fieldsByGroup.has(field.visualGroup)) {
              // Si el campo pertenece a un grupo visual, agregarlo al grupo
              const group = fieldsByGroup.get(field.visualGroup);
              group.fields.push(field);
              // Si es el primer campo del grupo, insertar el grupo en esta posición
              if (group.fields.length === 1) {
                return group;
              }
              return null; // No incluir el campo directamente
            }
            return field; // Mantener campos sin grupo visual
          })
          .filter(Boolean); // Eliminar los null

        // Los grupos visuales ahora se controlan con v-show
      } else {
        // Si no hay grupos visuales, usar los campos tal cual
        this.internalFields = [...this.fields];
      }
    },

    // Método para determinar si un campo debe mostrarse
    shouldShowField(field) {
      // Si es un grupo visual, solo mostrarlo si es el activo
      if (field.type === "group" && field.key.startsWith("group_")) {
        const groupName = field.key.replace("group_", "");
        return this.activeVisualGroup === groupName;
      }

      // Si no es un grupo visual, mostrarlo siempre
      return true;
    },
    // Verificar si el usuario puede ver un grupo visual
    canViewVisualGroup(field) {
      // Si no es un grupo, permitir
      if (field.type !== 'group') {
        return true;
      }
      
      // Extraer el nombre del grupo del key
      const groupName = field.key.replace("group_", "");
      const group = this.visualGroups?.find((g) => g.name === groupName);
      
      // Si no se encuentra el grupo, permitir por defecto
      if (!group) {
        return true;
      }
      
      // Si no hay restricciones, permitir por defecto
      if (!group.roleRestrictions || group.roleRestrictions.length === 0) {
        return true;
      }
      
      const userRole = localStorage.getItem("role");
      if (!userRole) {
        return false;
      }
      
      // Si es admin, puede ver todo
      if (userRole === "admin") {
        return true;
      }
      
      // Buscar restricción para el rol del usuario
      const restriction = group.roleRestrictions.find(r => r.roleName === userRole);
      if (!restriction) {
        // Si no hay restricción específica, permitir por defecto
        return true;
      }
      
      return restriction.canView !== false; // Por defecto true si no está definido
    },

    getFileName(file) {
      if (file) {
        const parts = file.split("/");
        return parts[parts.length - 1];
      }
      return "";
    },
    isFieldEmpty(field) {
      const value = this.formData[field.key];

      if (field.type == "reference" && field.addbutton) {
        return false;
      }

      if (field.isArray || field.type === "array") {
        return !value || value.length === 0;
      }
      if (field.type === "group") {
        return (
          !value ||
          Object.keys(value).length === 0 ||
          (typeof value === "object" &&
            value !== null &&
            Object.keys(value).length === 0)
        );
      }
      if (field.type === "boolean") {
        return false; // Mostrar siempre los booleanos
      }
      return value === undefined || value === null || value === "";
    },
    getFileIcon(file) {
      if (!file) return "insert_drive_file";
      const extension = file.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "picture_as_pdf";
        case "doc":
        case "docx":
          return "description";
        case "xls":
        case "xlsx":
          return "table_chart";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "image";
        case "mp3":
        case "wav":
          return "audiotrack";
        case "mp4":
        case "avi":
          return "videocam";
        default:
          return "insert_drive_file";
      }
    },
    getTruncatedFileName(file) {
      if (!file) return "";
      const fileName = file.split("/").pop();
      return fileName.length > 20
        ? fileName.substring(0, 20) + "..."
        : fileName;
    },

    async openReferenceModal(payload) {
      // El botón manda { field, row }; las llamadas viejas mandan el campo pelado.
      // El botón manda { field, item }; las llamadas viejas mandan el campo pelado.
      const field = payload && payload.field ? payload.field : payload;
      const parentItem = (payload && payload.field ? payload.item : null) || {};

      // Dentro de un grupo, cada fila la renderiza su propia instancia de ViewContent:
      // la línea es este formData, no el item de la pantalla (que es el embarque).
      const isNotaComercial =
        String(field && field.ref ? field.ref : "").toLowerCase() === "notacomercial";
      this.notaComercialSourceExpenseRow =
        isNotaComercial && isShippingExpenseRow(this.formData) ? this.formData : null;

      // Nota comercial desde una línea de gastos: va el popup del módulo, que ya trae la
      // variante, el contacto, la moneda y la aplicación al embarque, en vez del formulario
      // genérico del modelo entero.
      if (this.notaComercialSourceExpenseRow && this.$refs.notaComercialNoteModal) {
        const row = this.notaComercialSourceExpenseRow;
        const shippingId = String(row.shipping || row.parent || "");
        const shippingName =
          String(parentItem._id || "") === shippingId ? String(parentItem.name || "") : "";
        this.$refs.notaComercialNoteModal.open(
          notaComercialModalContextFromExpenseLine(row, this.lists, { shippingName })
        );
        return;
      }

      if (!this.parentID) {
        this.parentID =
          this.formData && this.formData._id ? this.formData._id : null;
      }

      this.currentReferenceField = field;
      try {
        // Use existing model definition if available, otherwise fetch it
        let modelDefinition;
        const existingModel = this.models.find(
          (m) => m.modelName === field.ref
        );
        if (existingModel) {
          modelDefinition = existingModel;
        } else {
          const sourceModel = this.originalSelectedModel || this.selectedModel;
          const { data } = await wencesApi.get(
            `/api/gotrading/model-definitions/${field.ref}?parentID=${this.parentID}&parentModel=${sourceModel}`
          );
          modelDefinition = data;
        }
        this.referenceModelFields = modelDefinition.fields;

        // Cargar el mapeo de referencias (sourceRecordId = shipping _id when creating payment from shipping)
        const sourceModel = this.originalSelectedModel || this.selectedModel;
        const sourceRecordId = this.parentID || (this.formData && this.formData._id) || null;
        const { data: referenceMapping } = await wencesApi.get(
          `/api/gotrading/model-reference-mapping`,
          {
            params: {
              sourceModel: sourceModel,
              targetModel: field.ref,
              ...(sourceRecordId ? { sourceRecordId } : {}),
            },
          }
        );

        // Crear el objeto base con custom_proform
        this.currentEditingItem = {};

        // Aplicar el mapeo si existe
        if (referenceMapping.data && referenceMapping.data.length > 0) {
          referenceMapping.data[0].mappings.forEach((mapping) => {
            if (
              this.originalFormData &&
              this.originalFormData[mapping.sourceField]
            ) {
              let value = this.originalFormData[mapping.sourceField];

              // Si es un array, limpiar los campos del sistema de cada item
              if (Array.isArray(value)) {
                value = value.map((item) => {
                  const cleanItem = { ...item };
                  // Si tiene un array de products, limpiar cada item
                  if (cleanItem.products && Array.isArray(cleanItem.products)) {
                    cleanItem.products = cleanItem.products.map((product) => {
                      const cleanProduct = { ...product };
                      delete cleanProduct._id;
                      delete cleanProduct.editHistory;
                      delete cleanProduct.createdAt;
                      delete cleanProduct.updatedAt;
                      delete cleanProduct.__v;
                      return cleanProduct;
                    });
                  }
                  return cleanItem;
                });
              }
              this.currentEditingItem[mapping.targetField] = value;
            }
          });
        }

        this.showReferenceModal = true;
      } catch (error) {
        console.error("Error loading reference model or mapping:", error);
        const code = error.response?.data?.code;
        const messageKey = error.response?.data?.messageKey;
        if (code === "SHIPPING_EXPENSE_REQUIRED") {
          const msg = messageKey ? this.$t(messageKey) : null;
          const text = msg && msg !== messageKey ? msg : (error.response?.data?.error || this.$t("paymentOrderRequiresExpense"));
          Swal.fire({
            icon: "warning",
            title: this.$tn("paymentOrderRequiresExpenseTitle") || "Attention",
            text,
          });
        }
      }
    },
    handleReferenceSaved(savedItem) {
      // Actualizar el campo de referencia con el nuevo elemento guardado
      if (this.currentReferenceField && savedItem) {
        // Si el campo es un array, agregar el nuevo elemento
        if (this.currentReferenceField.isArray) {
          if (!Array.isArray(this.formData[this.currentReferenceField.key])) {
            this.$set(this.formData, this.currentReferenceField.key, []);
          }
          this.formData[this.currentReferenceField.key].push(
            savedItem && savedItem._id ? savedItem._id : savedItem
          );
        } else {
          // Si es una referencia simple, asignar el nuevo elemento
          this.$set(
            this.formData,
            this.currentReferenceField.key,
            savedItem && savedItem._id ? savedItem._id : savedItem
          );
        }

        // Recargar las opciones de referencia para mostrar el nuevo elemento
        this.loadAllReferenceOptions();
      }

      // Emit event to parent component so it can refresh FinancialSummary if needed
      // Check if the saved item is a payment or collection
      const isPaymentOrCollection = this.currentReferenceField && 
        (this.currentReferenceField.ref?.toLowerCase() === 'payment' || 
         this.currentReferenceField.ref?.toLowerCase() === 'collect');
      
      if (isPaymentOrCollection) {
        this.$emit('reference-saved', savedItem);
      }

      if (this.notaComercialSourceExpenseRow && savedItem && savedItem._id) {
        this.linkNotaComercialToExpenseLine(this.notaComercialSourceExpenseRow, savedItem._id);
      }

      this.showReferenceModal = false;
      this.currentReferenceField = null;
      this.currentEditingItem = null;
      this.notaComercialSourceExpenseRow = null;
    },

    /**
     * Embarque contra el que se mide el efecto de las notas sobre este importe.
     * En la línea es el suyo; en el total del embarque, el embarque mismo.
     * @param {object} field
     * @returns {string}
     */
    /** Columna «En USD» después de la moneda de una línea de gastos del embarque (#397). */
    /**
     * La fila tal cual; si es un gasto del embarque sin moneda cargada, con la del proveedor
     * del embarque (currency_ps). Es la regla del cálculo de márgenes y del balance: sin
     * esto el mismo gasto salía sin moneda acá, en € en el resumen y en $ en el balance.
     */
    expenseRowWithCurrency() {
      const row = this.formData;
      if (!isShippingExpenseRow(row)) return row;
      const own = row.currencyex;
      if (own !== null && own !== undefined && own !== "") return row;
      const supplierCurrency = this.originalFormData && this.originalFormData.currency_ps;
      return supplierCurrency ? { ...row, currencyex: supplierCurrency } : row;
    },
    usdEquivalentAfterField(field) {
      return !!field && field.key === "currencyex" && isShippingExpenseRow(this.formData);
    },
    notaComercialShippingIdForAmountField(field) {
      const key = String((field && field.key) || "");
      if (key === "amount" && isShippingExpenseRow(this.formData)) {
        return String(this.formData.shipping || this.formData.parent || "");
      }
      if (key === "total_expenses" || key === "totalexpensestotal") {
        return String((this.formData && this.formData._id) || "");
      }
      return "";
    },

    /**
     * Datos para ofrecer notas que ya existen, o null si este campo no es el de notas
     * de una línea de gasto. Ahí el contacto y el embarque son los de la propia línea.
     * @param {object} field
     * @returns {{contactId: string, shippingId: string}|null}
     */
    notaComercialAssignDataForField(field) {
      const isNotaComercial =
        String((field && field.ref) || "").toLowerCase() === "notacomercial";
      if (!isNotaComercial || !isShippingExpenseRow(this.formData)) return null;
      const row = this.formData;
      const contactId = row.contact ? String(row.contact._id || row.contact) : "";
      const shippingId = String(row.shipping || row.parent || "");
      if (!contactId || !shippingId) return null;
      return { contactId, shippingId, expenseId: String(row._id || "") };
    },

    /**
     * Tras asignar una nota que ya existía, la pantalla tiene que releer: el vínculo con
     * la línea lo hace el backend al aplicarla, y los importes del resumen cambian.
     * @param {{noteId?: string}} payload
     */
    onNotaComercialAssignedToExpenseLine(payload) {
      this.$emit("reference-saved", { _id: (payload && payload.noteId) || "" });
    },

    /**
     * Desliga una nota de la línea de gasto: la quita del embarque (el backend la descuelga
     * de la línea y recalcula el balance) y la pantalla relee, igual que al asignarla.
     * @param {object} field
     * @param {string} noteId
     * @param {string} noteName
     */
    async unapplyNotaFromExpenseLine(field, noteId, noteName) {
      const data = this.notaComercialAssignDataForField(field);
      if (!data || !noteId) return;
      const parent = this.formData && (this.formData.parent || this.formData.shipping);
      const removed = await this.unapplyNotaComercialFromOperation({
        noteId,
        noteName,
        targetType: "shipping",
        targetId: data.shippingId,
        operationName: (parent && typeof parent === "object" && parent.name) || this.$tn("notaComercial.unapply.thisShipping"),
      });
      if (!removed) return;
      // La línea ya no la tiene en la base; la ficha del gasto no relee sola, así que se
      // saca de la lista acá (el embarque y la proforma sí releen con el evento).
      const keep = (list) =>
        (Array.isArray(list) ? list : []).filter((n) => String((n && n._id) || n) !== String(noteId));
      this.$set(this.formData, field.key, keep(this.formData[field.key]));
      if (this.originalFormData) this.$set(this.originalFormData, field.key, keep(this.originalFormData[field.key]));
      this.onNotaComercialAssignedToExpenseLine({ noteId });
    },

    /**
     * Notas cuyo efecto se muestra al lado de este importe, o null si no corresponde.
     * En la línea de gasto son las suyas; en el total del embarque, las de todas sus líneas.
     * @param {object} field
     * @returns {string[]|null}
     */
    notaComercialNoteIdsForAmountField(field) {
      const key = String((field && field.key) || "");
      const toIds = (list) =>
        (Array.isArray(list) ? list : [])
          .map((n) => (n && typeof n === "object" ? String(n._id || "") : String(n || "")))
          .filter(Boolean);

      if (key === "amount" && isShippingExpenseRow(this.formData)) {
        const ids = toIds(this.formData.commercialnotes);
        return ids.length ? ids : null;
      }

      if (key === "total_expenses" || key === "totalexpensestotal") {
        const rows = Array.isArray(this.formData && this.formData.expenses)
          ? this.formData.expenses
          : [];
        const ids = rows.reduce(
          (acc, row) => (row && typeof row === "object" ? acc.concat(toIds(row.commercialnotes)) : acc),
          []
        );
        return ids.length ? [...new Set(ids)] : null;
      }

      return null;
    },

    /**
     * Nota creada desde el popup del módulo: se cuelga de la línea y se limpia el contexto.
     * @param {object|null} savedNote
     */
    handleNotaComercialFromExpenseSaved(savedNote) {
      const row = this.notaComercialSourceExpenseRow;
      this.notaComercialSourceExpenseRow = null;
      if (row && savedNote && savedNote._id) {
        this.linkNotaComercialToExpenseLine(row, savedNote._id);
      }
    },

    /**
     * Cuelga la nota recién creada del campo commercialnotes de la línea de gasto.
     * El vínculo es informativo: si falla, la nota ya está creada y no se pierde nada,
     * así que no interrumpe con un cartel de error.
     * @param {object} row línea de shipping_expenses
     * @param {string} notaId
     */
    async linkNotaComercialToExpenseLine(row, notaId) {
      try {
        const current = Array.isArray(row.commercialnotes) ? row.commercialnotes : [];
        const ids = current
          .map((n) => (n && typeof n === "object" ? String(n._id || "") : String(n || "")))
          .filter(Boolean);
        if (ids.includes(String(notaId))) return;
        ids.push(String(notaId));
        await wencesApi.put(`/api/gotrading/dynamic/shipping_expenses/${row._id}`, {
          commercialnotes: ids,
        });
        this.$set(row, "commercialnotes", ids);
      } catch (error) {
        console.error("No se pudo vincular la nota comercial a la línea de gasto:", error);
      }
    },

    // Versión síncrona para usar en el template (muestra label simple si no hay parent)
    getHierarchicalLabelSync(field, value) {
      // Logs comentados para reducir ruido en consola
      // console.log('[ViewContent.getHierarchicalLabelSync] 🔍 Iniciando:', {...});

      if (!value || !value.label) {
        // console.log('[ViewContent.getHierarchicalLabelSync] ❌ No hay value o label');
        return "";
      }

      // Si no hay parent, es un elemento raíz - mostrar directamente
      if (!value.parent) {
        // console.log('[ViewContent.getHierarchicalLabelSync] ✅ Sin parent, retornando label directo:', value.label);
        return getTranslatedListLabel(value, this.$i18n.locale);
      }

      // Si tiene parent, verificar si ya tenemos el label jerárquico en cache
      const cacheKey = `${field.key}_${value._id}`;
      if (this.hierarchicalLabelsCache.has(cacheKey)) {
        // console.log('[ViewContent.getHierarchicalLabelSync] ✅ Label encontrado en cache');
        return this.hierarchicalLabelsCache.get(cacheKey);
      }

      // Si las listas ya están cargadas, calcular la jerarquía
      if (this.listsLoaded) {
        // console.log('[ViewContent.getHierarchicalLabelSync] 📡 Listas cargadas, calculando jerarquía');
        this.getHierarchicalLabel(field, value).then(label => {
          this.hierarchicalLabelsCache.set(cacheKey, label);
          this.$forceUpdate();
        });
        // Mientras tanto, mostrar el label simple
        return getTranslatedListLabel(value, this.$i18n.locale);
      }

      // Si no están cargadas, iniciar la carga y mostrar el label simple por ahora
      // Solo cargar una vez, no en cada llamada del template
      if (!this.loadingLists) {
        // console.log('[ViewContent.getHierarchicalLabelSync] 📡 Iniciando carga de lista:', field.listType);
        // Cargar solo la lista específica que necesitamos
        this.loadListsIfNeeded('getHierarchicalLabelSync', field.listType).then(() => {
          this.getHierarchicalLabel(field, value).then(label => {
            this.hierarchicalLabelsCache.set(cacheKey, label);
            this.$forceUpdate();
          });
        });
      } else {
        // console.log('[ViewContent.getHierarchicalLabelSync] ⏳ Listas ya se están cargando');
      }

      // Mientras tanto, mostrar el label simple
      // console.log('[ViewContent.getHierarchicalLabelSync] 📝 Retornando label simple mientras carga:', value.label);
      return getTranslatedListLabel(value, this.$i18n.locale);
    },

    // Versión asíncrona para construir la jerarquía completa
    async getHierarchicalLabel(field, value) {
      if (!value || !value.label) return "";

      // Si no hay parent, es un elemento raíz
      if (!value.parent) {
        return getTranslatedListLabel(value, this.$i18n.locale);
      }

      // Si tiene parent, necesitamos las listas para construir la jerarquía
      // Usar el listType del field para cargar solo la lista necesaria
      if (!this.listsLoaded && field.listType) {
        await this.loadListsIfNeeded('getHierarchicalLabel', field.listType);
      }

      // Obtener todos los ancestros recursivamente
      const ancestors = await this.getAncestors(field, value);
      
      // Construir la cadena completa de jerarquía
      const loc = this.$i18n.locale;
      const labels = ancestors.map((ancestor) => getTranslatedListLabel(ancestor, loc));
      return labels.join(" > ");
    },

    // Obtener todos los ancestros de un elemento (desde la raíz hasta el elemento)
    async getAncestors(field, item, visited = new Set()) {
      if (!item || !item._id) return [];
      
      // Evitar ciclos infinitos
      if (visited.has(item._id)) return [item];
      visited.add(item._id);

      // Si tiene parent, necesitamos las listas para buscar el parent
      // Solo cargar si no tenemos la lista específica ya cargada
      if (item.parent && field.listType) {
        const existingList = this.internalLists.find(l => l.type === field.listType);
        if (!existingList && !this.loadingLists) {
          await this.loadListsIfNeeded('getAncestors', field.listType);
        }
      }

      const listOptions = this.getListOptions(field);
      const ancestors = [item];

      // Si tiene parent, buscar recursivamente
      if (item.parent) {
        // Convertir parent a string para comparación (manejar ObjectId, string, etc.)
        let parentId;
        if (item.parent && typeof item.parent === 'object' && item.parent.toString) {
          parentId = item.parent.toString();
        } else {
          parentId = String(item.parent);
        }
        
        // Buscar el parent en la lista
        const parent = listOptions.find((p) => {
          if (!p || !p._id) return false;
          // Convertir el _id del item de la lista a string para comparar
          let pId;
          if (typeof p._id === 'object' && p._id.toString) {
            pId = p._id.toString();
          } else {
            pId = String(p._id);
          }
          return pId === parentId;
        });
        
        if (parent) {
          // Obtener ancestros del padre primero
          const parentAncestors = await this.getAncestors(field, parent, visited);
          // Combinar: ancestros del padre + elemento actual
          return [...parentAncestors, item];
        }
      }

      return ancestors;
    },

    async loadListsIfNeeded(callerName = 'unknown', listType = null) {
      // Si ya están cargadas o se están cargando, no hacer nada
      if (this.listsLoaded || this.loadingLists) {
        if (this.listsLoaded) {
          return;
        } else if (this.loadingLists) {
          return;
        }
      }

      // Si se especifica un listType, verificar si ya tenemos esa lista cargada
      if (listType) {
        const existingList = this.internalLists.find(l => l.type === listType);
        if (existingList) {
          return;
        }
      }

      this.loadingLists = true;
      try {
        let data;
        if (listType) {
          // Cargar solo la lista específica que necesitamos
          const response = await wencesApi.get(`/api/gotrading/lists/type/${listType}`);
          data = [response.data]; // Convertir a array para mantener consistencia
        } else {
          // Fallback: cargar todas las listas
          const response = await wencesApi.get("/api/gotrading/lists");
          data = response.data;
        }
        
        // Agregar o actualizar en internalLists
        if (listType) {
          // Si es una lista específica, agregarla o reemplazarla
          const existingIndex = this.internalLists.findIndex(l => l.type === listType);
          if (existingIndex >= 0) {
            this.internalLists[existingIndex] = data[0];
          } else {
            this.internalLists.push(data[0]);
          }
        } else {
          this.internalLists = data;
          this.listsLoaded = true;
        }
        
        // Limpiar cache de labels jerárquicos para recalcularlos
        this.hierarchicalLabelsCache.clear();
        // Forzar actualización del componente para mostrar las jerarquías
        this.$forceUpdate();
      } catch (error) {
        console.error('[ViewContent.loadListsIfNeeded] ❌ Error loading lists:', error);
        if (!listType) {
          // Solo limpiar si era carga completa
          this.internalLists = [];
        }
      } finally {
        this.loadingLists = false;
      }
    },

    getListOptions(field) {
      console.log('[ViewContent.getListOptions] 🔍 Iniciando búsqueda:', {
        fieldKey: field.key,
        fieldListType: field.listType,
        fieldListRef: field.listRef,
        isSubform: this.subform,
        internalListsCount: this.internalLists?.length || 0,
        referenceItemsCount: this.referenceItems?.length || 0,
        listsPropsCount: this.lists?.length || 0
      });

      // Si tiene listRef, buscar en las opciones de referencia
      if (field.listRef) {
        if (this.referenceOptions && this.referenceOptions[field.listRef]) {
          console.log('[ViewContent.getListOptions] ✅ Opciones encontradas en referenceOptions:', field.listRef);
          return this.referenceOptions[field.listRef];
        }
      }

      // Buscar en todas las fuentes disponibles en orden de prioridad:
      // 1. internalLists (listas cargadas bajo demanda)
      // 2. referenceItems (listas cargadas tradicionalmente)
      // 3. lists (props - especialmente importante para subforms)
      let availableLists = [];
      if (this.internalLists && this.internalLists.length > 0) {
        availableLists = this.internalLists;
        console.log('[ViewContent.getListOptions] 📦 Usando internalLists:', availableLists.length, 'listas');
      } else if (this.referenceItems && this.referenceItems.length > 0) {
        availableLists = this.referenceItems;
        console.log('[ViewContent.getListOptions] 📦 Usando referenceItems:', availableLists.length, 'listas');
      } else if (this.lists && this.lists.length > 0) {
        availableLists = this.lists;
        console.log('[ViewContent.getListOptions] 📦 Usando lists (props):', availableLists.length, 'listas', {
          availableTypes: availableLists.map(l => l.type)
        });
      } else {
        console.log('[ViewContent.getListOptions] ❌ No hay listas disponibles en ninguna fuente');
      }

      // Si tiene listType, buscar en las listas disponibles
      if (field.listType) {
        const list = availableLists.find((l) => l.type === field.listType);
        if (list && list.values) {
          console.log('[ViewContent.getListOptions] ✅ Lista encontrada:', field.listType, 'con', list.values.length, 'valores');
          return list.values;
        } else {
          console.log('[ViewContent.getListOptions] ❌ Lista NO encontrada:', field.listType);
        }
      }

      // Si no tiene listRef ni listType, intentar buscar por el nombre del campo
      if (availableLists.length > 0) {
        const list = availableLists.find((l) => l.type === field.key);
        if (list && list.values) {
          console.log('[ViewContent.getListOptions] ✅ Lista encontrada por field.key:', field.key);
          return list.values;
        }
      }

      console.log('[ViewContent.getListOptions] ❌ Retornando array vacío');
      return [];

      return [];
    },

    async handleFieldUpdated(event) {
      const { fieldKey, itemId, value } = event;

      try {
        // Actualizar el valor local
        this.$set(this.formData, fieldKey, value);

        const updateData = {
          [fieldKey]: value,
          partialUpdate: true, // Indicar que es una actualización parcial
        };

        // Enviar la actualización al servidor
        await wencesApi.put(
          `/api/gotrading/dynamic/${this.selectedModel}/${itemId}`,
          updateData
        );
      } catch (error) {
        console.error("❌ ViewContent: Error updating field:", error);

        // Revertir el cambio local en caso de error
        this.$set(this.formData, fieldKey, this.originalFormData[fieldKey]);
        console.error("Error updating field:", error);
      }
    },
    openImageInNewTab(imageUrl) {
      if (imageUrl) {
        window.open(imageUrl, '_blank');
      }
    },
  },
  computed: {
    wrapFieldsInRow() {
      return (
        !this.subform &&
        !this.multiple &&
        (this.detailHalfWidthFields ||
          (this.visualGroups && this.visualGroups.length > 0))
      );
    },
    nonEmptyFields() {
      return this.internalFields.filter((field) => {
        if (field.hidedisplay) return false;
        // Siempre mostrar botones
        if (field.type === "button") return true;
        // Siempre mostrar campos reference (vacíos o no), así se ve el botón "Crear" cuando tienen addbutton
        if (field.type === "reference") return true;
        // Mostrar grupos visuales que contengan algún reference (para que no se oculten por estar "vacíos")
        if (
          field.type === "group" &&
          field.fields &&
          field.fields.some((f) => f.type === "reference")
        )
          return true;
        return !this.isFieldEmpty(field);
      });
    },
  },
  components: {
    FieldHistoryLabelButton,
    GroupIcon,
    NotaComercialAmountNet,
    OperationUsdEquivalent,
    NotaComercialNoteModal,
    NotaComercialAssignButton,
    Multiselect,
    Form: () => import("./ViewContent.vue"),
    FileDisplay,
    ReferenceModal: () => import("./ReferenceModal.vue"),
    ListEditField,
    FieldText,
    FieldList,
    FieldNumber,
    FieldDate,
    FieldBoolean,
    FieldSelect,
    FieldTextList,
    FieldReference,
    FieldFile,
    ShippingStatusBadge,
  },
};
</script>
<style>
@media (max-width: 767.98px) {
  .view-content-layout .row > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .view-content-layout .float-left-auto {
    float: none !important;
    width: 100% !important;
    max-width: 100% !important;
  }
}

.float-left-auto {
  float: left;
  width: auto;
}

.view-image-container {
  display: inline-block;
}

.view-image {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.view-image:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>


<style>
/* Teléfono: cada línea de un grupo (gastos, pagos, documentos del detalle)
   apilaba sus campos a todo el ancho y un gasto medía ~650px. Los campos van
   en dos columnas con el título chico; lo que lleva botones o texto largo
   ocupa las dos. Solo CSS: el markup y los ids no cambian. */
@media (max-width: 767.98px) {
  .group-isarray div:has(> .float-left-auto) {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.35rem 0.75rem;
  }

  .group-isarray div:has(> .float-left-auto) > .float-left-auto {
    min-width: 0;
    width: auto !important;
    margin: 0 !important;
    float: none !important;
    text-align: left !important;
  }

  .group-isarray div:has(> .float-left-auto) > .float-left-auto:is(.text, .textarea, .html, .file, .group),
  .group-isarray div:has(> .float-left-auto) > .float-left-auto.reference:has(.btn) {
    grid-column: 1 / -1;
  }

  .group-isarray .float-left-auto .form-label {
    margin-bottom: 0.1rem !important;
    font-size: 0.72rem;
    text-align: left !important;
    color: var(--bs-secondary-color);
  }

  .group-isarray .float-left-auto .form-label strong {
    font-weight: 600;
  }

  .group-isarray .float-left-auto :is(.text-end, .justify-content-end) {
    text-align: left !important;
    justify-content: flex-start !important;
  }
}
</style>
